import { motion } from "framer-motion";
import { EXPERIENCE } from "../data/portfolio";
import { Reveal } from "./Reveal";

export const Experience = () => {
  return (
    <section
      id="experience"
      data-testid="experience-section"
      className="relative border-t border-white/10 py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-y-10 gap-x-0 lg:gap-10 mb-16">
          <div className="col-span-12 lg:col-span-4">
            <Reveal>
              <p className="label-eyebrow">03 / Trajectory</p>
              <h2 className="mt-4 font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-tight">
                Seven years,
                <br />
                <span className="text-white/40">four chapters.</span>
              </h2>
            </Reveal>
          </div>
          <Reveal
            delay={150}
            className="col-span-12 lg:col-span-8 lg:pl-8 lg:border-l lg:border-white/10"
          >
            <p className="text-base sm:text-lg text-white/70 leading-relaxed">
              I&apos;ve shipped production software at four engineering-led
              organisations — moving from front-end fundamentals to full-stack
              systems to building generative AI products.
            </p>
          </Reveal>
        </div>

        <div className="border-t border-white/10">
          {EXPERIENCE.map((job, i) => (
            <Reveal
              key={job.company}
              delay={i * 100}
              className="block"
              data-testid={`experience-row-${job.company
                .toLowerCase()
                .replace(/[^a-z]/g, "")}`}
            >
              <motion.div
                whileHover={{ backgroundColor: "rgba(255,255,255,0.025)" }}
                transition={{ duration: 0.3 }}
                className="group relative py-10 md:py-14 border-b border-white/10"
              >
                <span className="pointer-events-none absolute left-0 top-0 bottom-0 w-px bg-white scale-y-0 group-hover:scale-y-100 origin-top transition-transform duration-500" />

                <div className="grid grid-cols-12 gap-6">
                  {/* Index */}
                  <div className="col-span-2 sm:col-span-1 label-eyebrow pt-2">
                    0{EXPERIENCE.length - i}
                  </div>

                  {/* Company + role */}
                  <div className="col-span-10 sm:col-span-4">
                    <h3 className="font-display font-bold text-2xl sm:text-3xl tracking-tighter flex items-center flex-wrap gap-3">
                      {job.company}
                      {job.current && (
                        <span className="inline-block text-[10px] font-mono uppercase tracking-[0.2em] text-emerald-400 border border-emerald-400/40 px-2 py-1">
                          Now
                        </span>
                      )}
                    </h3>
                    <p className="mt-2 label-eyebrow">{job.role}</p>
                    {job.location && (
                      <p className="mt-1 text-xs text-white/40 font-mono">
                        {job.location}
                      </p>
                    )}
                  </div>

                  {/* Summary + bullets + stack */}
                  <div className="col-span-12 sm:col-span-5">
                    <p className="text-sm sm:text-base text-white/75 leading-relaxed">
                      {job.summary}
                    </p>

                    {job.bullets && job.bullets.length > 0 && (
                      <ul className="mt-5 space-y-3">
                        {job.bullets.map((b) => (
                          <li
                            key={b}
                            className="flex gap-3 text-sm text-white/65 leading-relaxed"
                          >
                            <span className="mt-2 flex-shrink-0 w-1.5 h-1.5 bg-white/60" />
                            <span>{b}</span>
                          </li>
                        ))}
                      </ul>
                    )}

                    <div className="mt-5 flex flex-wrap gap-2">
                      {job.stack.map((t) => (
                        <span
                          key={t}
                          className="text-[10px] font-mono uppercase tracking-[0.18em] text-white/60 border border-white/15 px-2 py-1"
                        >
                          {t}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Period */}
                  <div className="col-span-12 sm:col-span-2 sm:text-right">
                    <p className="label-eyebrow">{job.period}</p>
                  </div>
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
